export default "__VITE_ASSET__DVIHj3md__"